import React, { Component,Fragment } from "react";
import { withRouter } from "react-router-dom";
// import { withAlert } from 'react-alert';
import {
  Card,
  CardBody,
  Col,
  Row,
  Input,
  Progress,
  CardHeader,
} from "reactstrap";

import { Table, Button, Tooltip, message } from "antd";
// import coin1 from "assets/img/coin1.png";
// import coin2 from "assets/img/coin2.png";
// import coin3 from "assets/img/coin3.png";
// import BarChart from 'components/charts/BarChart';
import moment from "moment";
import axios from "axios";
import "./dashboard.css";
import { connect } from "react-redux";
// import { login, logout } from 'store/auth/actions';
// import { addParams } from 'store/route-params/actions';
// import apiurl from '../../../../apiurl';
import BlockUi from "react-block-ui";
import store from "../../store/store";

import { mcqSubjectNames } from "services/utility";

const mapStateToProps = (state) => {
  const user = state.user;
  return {
    schoolId: user && user.school_id,
    gradeId: user.grade_id !== 0 ? user.grade_id : "5e8c420b0325791cf604590b",
    gradeName: user && user.grade_name,
    boardId: user && user.boardId,
    subjectId: user && user.subjectId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
  // login: (payload) => {
  //     dispatch(login(payload))
  // },
  // addParams: (payload) => {
  //     dispatch(addParams(payload));
  // }
};

export class TeacherDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      schoolId: "",
      gradeId: "",
      subjectId: "",
      subjectTitle: "",
      MainSubjectTitle: "",
      chapterId: "",
      studentTblcolumns: [],
      studentTblData: [],
      ovsPercentage: [],
      ovStudentCount: [],
      chapterDrillData: [],
      topicDrillData: [],
      chapterSummaryArrData: [],
      topicFlag: false,
      currentSelectedFlg: "subject",
      subjectAttempt: "",
      chapterAttempt: "",
      topicAttempt: "",
      pagination: {},
      showCompletionSec: false,
      searchFlag: false,
      pageLoader: false,
      userData: {},
    };

    this.handleTableChange = this.handleTableChange.bind(this);
    this.downloadCsv = this.downloadCsv.bind(this);
    this.downloadChapterwiseCsv = this.downloadChapterwiseCsv.bind(this);
  }

  btnBack() {
    this.props.history.goBack();
    // let path = `/principal`;
    // this.props.history.push({
    //     pathname: path,
    //     //   state: {
    //     //     type: tblTypeTitle,
    //     //     detail: selectedData
    //     //   }
    // });
  }

  async getChapterCompletionCount() {
    try {
      let chapterCompletionCount;
      let selectedGrade_id_statisticApi = localStorage.getItem(
        "selectedGrade_id_statisticApi"
      );
      console.log(selectedGrade_id_statisticApi);
      console.log(selectedGrade_id_statisticApi === "");
      let selectedGrade_Name =
        localStorage.getItem("selectedGrade_Name") !== "undefined" &&
        localStorage.getItem("selectedGrade_Name")
          ? localStorage.getItem("selectedGrade_Name")
          : this.state.userData.grade_name;
      if (selectedGrade_id_statisticApi === "") {
        chapterCompletionCount = await axios.post(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/chaptercompletioncount-dev",
          {
            schoolId: this.props.schoolId,
            gradeId: this.state.gradeId,
            grade: selectedGrade_Name,
            subjectId: this.state.subjectId,
            chapterId: this.state.chapterId,
            param: "all",
          }
        );
      } else {
        chapterCompletionCount = await axios.post(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/chaptercompletioncount-dev",
          {
            schoolId: this.props.schoolId,
            gradeId: this.state.gradeId,
            grade: selectedGrade_Name,
            subjectId: this.state.subjectId,
            chapterId: this.state.chapterId,
          }
        );
      }
      chapterCompletionCount = chapterCompletionCount.data;
      let chapterNotAttempted =
        chapterCompletionCount.chapter.card.chapterNotAttempted;
      let chapterCompletion =
        chapterCompletionCount.chapter.card.chapterCompletion;
      let onlyTopicAttempt =
        chapterCompletionCount.chapter.card.onlyTopicAttempt;

      this.setState({
        notCompletedchapter: chapterNotAttempted,
        chapterCompletion: chapterCompletion,
        onlyTopicAttempt: onlyTopicAttempt,
        showCompletionSec: selectedGrade_id_statisticApi === "" ? false : true,
      });
    } catch (err) {
      console.log(err);
    }
  }

  //============== GET ALL SUBJECT DATA ===============//

  async getData(propdata) {
    try {
      console.log(this.props);
      let subjectDetailResult;
      let selectedGrade_id_statisticApi = localStorage.getItem(
        "selectedGrade_id_statisticApi"
      );
      let selectedGrade_Name = this.props.gradeName;

      if (selectedGrade_id_statisticApi === "") {
        subjectDetailResult = await axios.get(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/getsubjectinfo-dev",
          {
            params: {
              schoolId: this.props.schoolId,
              gradeId: this.props.gradeId,
              grade: selectedGrade_Name,
              subjectId: this.props.subjectId,
              param: "all",
              page: 1,
            },
          }
        );
      } else {
        subjectDetailResult = await axios.get(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/getsubjectinfo-dev",
          {
            params: {
              schoolId: this.props.schoolId,
              gradeId: this.props.gradeId,
              grade: selectedGrade_Name,
              subjectId: this.props.subjectId,
              page: 1,
            },
          }
        );
      }
      subjectDetailResult = subjectDetailResult.data;
      console.log(subjectDetailResult);
      let subjectAttempt = subjectDetailResult.subject.card.subjectAttempt;
      let chapterAttempt = subjectDetailResult.subject.card.chapterAttempt;
      let topicAttempt = subjectDetailResult.subject.card.topicAttempt;
      let chapterSummaryArrData =
        subjectDetailResult.subject.card.chapterCompletion;
      let chapterDrillData =
        subjectDetailResult.subject.stats.score.chapter_score;
      let subjectTitle = subjectDetailResult.subject.subject_name;
      // let barChartData = subjectDetailResult.subject.stats.score.overall_score[0].score;

      // let ovsPercentage = []
      // let ovStudentCount = []

      // for (let i = 0; i < barChartData.length; i++) {
      //     ovsPercentage.push(barChartData[i].Percent);
      //     ovStudentCount.push(barChartData[i].StudentCount);
      // }
      let subjectStuData =
        subjectDetailResult.subject.stats.subjectwise_student_score;

      for (let i = 0; i < subjectStuData.length; i++) {
        subjectStuData[i].key = i;
      }

      let pagiObj = {};
      pagiObj.total = subjectDetailResult.subject.stats.students;
      pagiObj.current = 1;

      this.setState({
        MainSubjectTitle: subjectTitle,
        subjectTitle: subjectTitle,
        studentTblData: subjectStuData,
        // ovsPercentage: ovsPercentage,
        // ovStudentCount: ovStudentCount,
        chapterDrillData: chapterDrillData,
        chapterSummaryArrData: chapterSummaryArrData,
        schoolId: this.props.schoolId,
        gradeId: this.props.gradeId,
        subjectId: this.props.subjectId,
        topicFlag: false,
        pagination: pagiObj,
        currentSelectedFlg: "subject",
        subjectAttempt: subjectAttempt,
        chapterAttempt: chapterAttempt,
        topicAttempt: topicAttempt,
        pageLoader: false,
      });
    } catch (err) {
      console.log(err);
      console.log("No Data - Error in API !!!!");
      this.props.changeRouteHandler();
    }
  }

  //============== GET ALL CHAPTER DATA ===============//

  async getchapterDrillData(data) {
    try {
      let chapterDetailResult;
      let selectedGrade_id_statisticApi = localStorage.getItem(
        "selectedGrade_id_statisticApi"
      );
      let selectedGrade_Name =
        localStorage.getItem("selectedGrade_Name") !== "undefined" &&
        localStorage.getItem("selectedGrade_Name")
          ? localStorage.getItem("selectedGrade_Name")
          : this.state.userData.grade_name;
      if (selectedGrade_id_statisticApi === "") {
        chapterDetailResult = await axios.get(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/getchapterinfo-dev",
          {
            params: {
              schoolId: this.props.schoolId,
              gradeId: this.state.gradeId,
              grade: selectedGrade_Name,
              subjectId: this.state.subjectId,
              chapterId: data.chapter_id,
              param: "all",
              page: 1,
            },
          }
        );
      } else {
        chapterDetailResult = await axios.get(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/getchapterinfo-dev",
          {
            params: {
              schoolId: this.props.schoolId,
              gradeId: this.state.gradeId,
              grade: selectedGrade_Name,
              subjectId: this.state.subjectId,
              chapterId: data.chapter_id,
              page: 1,
            },
          }
        );
      }
      chapterDetailResult = chapterDetailResult.data;
      console.log(chapterDetailResult);
      // let chapterNotAttempted = chapterDetailResult.chapter.card.chapterNotAttempted;
      // let chapterCompletion = chapterDetailResult.chapter.card.chapterCompletion;
      // let onlyTopicAttempt = chapterDetailResult.chapter.card.onlyTopicAttempt;
      if (chapterDetailResult.chapter.length !== 0) {
        let barDataArr = chapterDetailResult.chapter.stats.score.overall_score;
        let ovsPercentage = [];
        let ovStudentCount = [];
        if (barDataArr.length !== 0) {
          let barChartData =
            chapterDetailResult.chapter.length !== 0
              ? chapterDetailResult.chapter.stats.score.overall_score[0].score
              : "";
          for (let i = 0; i < barChartData.length; i++) {
            ovsPercentage.push(barChartData[i].Percent);
            ovStudentCount.push(barChartData[i].StudentCount);
          }
        }

        let subjectStuData =
          chapterDetailResult.chapter.stats.chapterwise_student_score;
        let topicDrillData =
          chapterDetailResult.chapter.stats.score.topic_score;
        for (let i = 0; i < subjectStuData.length; i++) {
          subjectStuData[i].key = i;
        }
        let pagiObj = {};
        pagiObj.total = chapterDetailResult.chapter.stats.students;
        pagiObj.current = 1;
        console.log(pagiObj);

        this.setState(
          {
            subjectTitle: "Chapter : " + data.chapter_name,
            studentTblData: subjectStuData,
            ovsPercentage: ovsPercentage,
            ovStudentCount: ovStudentCount,
            topicDrillData: topicDrillData,
            chapterId: data.chapter_id,
            topicFlag: false,
            currentSelectedFlg: "chapter",
            pagination: pagiObj,
            chapter_name: data.chapter_name,
          },
          () => {
            this.getChapterCompletionCount();
          }
        );
      } else {
        // message.error("No Data");
        const alert = this.props.alert;
        alert.error("No Data");
        this.setState({
          subjectTitle: "Chapter : " + data.chapter_name,
          studentTblData: [],
          topicDrillData: [],
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  //============== GET ALL TOPIC DATA ===============//

  async getTopicDrillData(data) {
    try {
      let topicDetailResult;
      let selectedGrade_id_statisticApi = localStorage.getItem(
        "selectedGrade_id_statisticApi"
      );
      let selectedGrade_Name =
        localStorage.getItem("selectedGrade_Name") !== "undefined" &&
        localStorage.getItem("selectedGrade_Name")
          ? localStorage.getItem("selectedGrade_Name")
          : this.state.userData.grade_name;
      if (selectedGrade_id_statisticApi === "") {
        topicDetailResult = await axios.get(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/gettopicinfo-dev",
          {
            params: {
              schoolId: this.props.schoolId,
              gradeId: this.state.gradeId,
              grade: selectedGrade_Name,
              subjectId: this.state.subjectId,
              chapterId: this.state.chapterId,
              topicId: data.topic_id,
              param: "all",
              page: 1,
            },
          }
        );
      } else {
        topicDetailResult = await axios.get(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/gettopicinfo-dev",
          {
            params: {
              schoolId: this.props.schoolId,
              gradeId: this.state.gradeId,
              grade: selectedGrade_Name,
              subjectId: this.state.subjectId,
              chapterId: this.state.chapterId,
              topicId: data.topic_id,
              page: 1,
            },
          }
        );
      }
      topicDetailResult = topicDetailResult.data;
      let barChartData =
        topicDetailResult.topic.length !== 0
          ? topicDetailResult.topic.stats.score.overall_score[0].score
          : "";
      let ovsPercentage = [];
      let ovStudentCount = [];
      for (let i = 0; i < barChartData.length; i++) {
        ovsPercentage.push(barChartData[i].Percent);
        ovStudentCount.push(barChartData[i].StudentCount);
      }
      if (topicDetailResult.topic.length !== 0) {
        let subjectStuData =
          topicDetailResult.topic.stats.topicwise_student_score;
        for (let i = 0; i < subjectStuData.length; i++) {
          subjectStuData[i].key = i;
        }
        let pagiObj = {};
        pagiObj.total = topicDetailResult.topic.stats.students;
        pagiObj.current = 1;

        this.setState({
          subjectTitle: "Topic : " + data.topic_name,
          studentTblData: subjectStuData,
          ovsPercentage: ovsPercentage,
          ovStudentCount: ovStudentCount,
          topicFlag: true,
          currentSelectedFlg: "topic",
          topicId: data.topic_id,
          pagination: pagiObj,
          topic_name: data.topic_name,
        });
      } else {
        // message.error("No Data");
        const alert = this.props.alert;
        alert.error("No Data");
        this.setState({
          subjectTitle: "Topic : " + data.topic_name,
          studentTblData: [],
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  getStudentDetail(selectedRowKeys, selectedRows) {
    let selectedUser_id = selectedRows.user_id;
    let selectedGrade_id = localStorage.getItem("selectedGrade_id"); // Grade ID
    // let login_data = JSON.parse(localStorage.getItem('login_data'))
    // let selectedBoard_id = login_data.data.board.board_id;     // Board ID
    let selectedBoard_id = localStorage.getItem("finalBoard_id"); // Board ID
    let selectedGrade_Name =
      localStorage.getItem("selectedGrade_Name") !== "undefined" &&
      localStorage.getItem("selectedGrade_Name")
        ? localStorage.getItem("selectedGrade_Name")
        : this.state.userData.grade_name;
    let boardIdOtherGrades = localStorage.getItem("boardIdOtherGrades"); // Board ID Other Grade
    let selectedGrade_id_statisticApi = localStorage.getItem(
      "selectedGrade_id_statisticApi"
    );
    let payload;
    if (selectedGrade_id_statisticApi === "") {
      payload = {
        studentId: selectedUser_id,
        gradeId: selectedGrade_id,
        boardId: boardIdOtherGrades,
        grade: selectedGrade_Name,
        filter: "day",
        param: "all",
      };
    } else {
      payload = {
        studentId: selectedUser_id,
        gradeId: selectedGrade_id,
        boardId: selectedBoard_id,
        grade: selectedGrade_Name,
        filter: "day",
      };
    }
    // this.props.addParams(payload);
    // this.props.history.push('/parent/dashboard');
    // this.props.history.push('/dashboard/student-detail');
    this.props.history.push({
      pathname: "/student-detail",
      state: {
        studentId: selectedUser_id,
        gradeId: selectedGrade_id,
        boardId: selectedBoard_id,
        grade: selectedGrade_Name,
        filter: "day",
      },
    });

    window.scrollTo(0, 0);
  }

  async reIndexData(selectedRowKeys, selectedRows) {
    let selectedUser_id = selectedRows.user_id;
    console.log(selectedUser_id);
    if (selectedUser_id === undefined) {
      message.error("Indexing failed user id not found");
    } else {
      const payload = {
        id: selectedUser_id,
      };
      let url =
        "https://8ytwl5trrl.execute-api.ap-south-1.amazonaws.com/PROD/process-user-lrs";
      let res = await axios.post(url, payload);
      console.log(res);
      message.success("Indexing successfull");
    }
  }

  //================= PAGINATION NEXT CLICK ================

  async handleTableChange(pagination, filters, sorter) {
    try {
      if (this.state.searchFlag === false) {
        this.setState({
          pageLoader: true,
        });

        //============== SUBJECT ===============
        if (this.state.currentSelectedFlg === "subject") {
          let subjectDetailResult;
          let selectedGrade_id_statisticApi = localStorage.getItem(
            "selectedGrade_id_statisticApi"
          );
          let selectedGrade_Name =
            localStorage.getItem("selectedGrade_Name") !== "undefined" &&
            localStorage.getItem("selectedGrade_Name")
              ? localStorage.getItem("selectedGrade_Name")
              : this.state.userData.grade_name;

          if (selectedGrade_id_statisticApi === "") {
            subjectDetailResult = await axios.get(
              "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/getsubjectinfo-dev",
              {
                params: {
                  schoolId: this.props.schoolId,
                  gradeId: this.state.gradeId,
                  grade: selectedGrade_Name,
                  subjectId: this.state.subjectId,
                  param: "all",
                  page: pagination.current,
                },
              }
            );
          } else {
            subjectDetailResult = await axios.get(
              "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/getsubjectinfo-dev",
              {
                params: {
                  schoolId: this.props.schoolId,
                  gradeId: this.state.gradeId,
                  grade: selectedGrade_Name,
                  subjectId: this.state.subjectId,
                  page: pagination.current,
                },
              }
            );
          }
          subjectDetailResult = subjectDetailResult.data;

          let subjectStuData =
            subjectDetailResult.subject.stats.subjectwise_student_score;
          for (let i = 0; i < subjectStuData.length; i++) {
            subjectStuData[i].key = i;
          }
          let pageObj = {};
          pageObj.total = subjectDetailResult.subject.stats.students;
          pageObj.current = pagination.current;
          this.setState({
            studentTblData: subjectStuData,
            pagination: pageObj,
            pageLoader: false,
          });
        }

        //============  CHAPTER ==================

        if (this.state.currentSelectedFlg === "chapter") {
          let chapterDetailResult;
          let selectedGrade_id_statisticApi = localStorage.getItem(
            "selectedGrade_id_statisticApi"
          );
          let selectedGrade_Name =
            localStorage.getItem("selectedGrade_Name") !== "undefined" &&
            localStorage.getItem("selectedGrade_Name")
              ? localStorage.getItem("selectedGrade_Name")
              : this.state.userData.grade_name;
          if (selectedGrade_id_statisticApi === "") {
            chapterDetailResult = await axios.get(
              "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/getchapterinfo-dev",
              {
                params: {
                  schoolId: this.props.schoolId,
                  gradeId: this.state.gradeId,
                  grade: selectedGrade_Name,
                  subjectId: this.state.subjectId,
                  chapterId: this.state.chapterId,
                  param: "all",
                  page: pagination.current,
                },
              }
            );
          } else {
            chapterDetailResult = await axios.get(
              "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/getchapterinfo-dev",
              {
                parasms: {
                  schoolId: this.props.schoolId,
                  gradeId: this.state.gradeId,
                  grade: selectedGrade_Name,
                  subjectId: this.state.subjectId,
                  chapterId: this.state.chapterId,
                  page: pagination.current,
                },
              }
            );
          }
          chapterDetailResult = chapterDetailResult.data;

          let subjectStuData =
            chapterDetailResult.chapter.stats.chapterwise_student_score;
          for (let i = 0; i < subjectStuData.length; i++) {
            subjectStuData[i].key = i;
          }

          let pageObj = {};
          pageObj.total = chapterDetailResult.chapter.stats.students;
          pageObj.current = pagination.current;

          this.setState({
            studentTblData: subjectStuData,
            pagination: pageObj,
            pageLoader: false,
          });
        }

        //============  TOPIC =====================

        if (this.state.currentSelectedFlg === "topic") {
          let topicDetailResult;
          let selectedGrade_id_statisticApi = localStorage.getItem(
            "selectedGrade_id_statisticApi"
          );
          let selectedGrade_Name =
            localStorage.getItem("selectedGrade_Name") !== "undefined" &&
            localStorage.getItem("selectedGrade_Name")
              ? localStorage.getItem("selectedGrade_Name")
              : this.state.userData.grade_name;

          if (selectedGrade_id_statisticApi === "") {
            topicDetailResult = await axios.get(
              "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/gettopicinfo-dev",
              {
                params: {
                  schoolId: this.props.schoolId,
                  gradeId: this.state.gradeId,
                  grade: selectedGrade_Name,
                  subjectId: this.state.subjectId,
                  chapterId: this.state.chapterId,
                  topicId: this.state.topicId,
                  param: "all",
                  page: pagination.current,
                },
              }
            );
          } else {
            topicDetailResult = await axios.get(
              "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/gettopicinfo-dev",
              {
                params: {
                  schoolId: this.props.schoolId,
                  gradeId: this.state.gradeId,
                  grade: selectedGrade_Name,
                  subjectId: this.state.subjectId,
                  chapterId: this.state.chapterId,
                  topicId: this.state.topicId,
                  page: pagination.current,
                },
              }
            );
          }
          topicDetailResult = topicDetailResult.data;

          let subjectStuData =
            topicDetailResult.topic.stats.topicwise_student_score;
          for (let i = 0; i < subjectStuData.length; i++) {
            subjectStuData[i].key = i;
          }

          let pageObj = {};
          pageObj.total = topicDetailResult.chapter.stats.students;
          pageObj.current = pagination.current;

          this.setState({
            studentTblData: subjectStuData,
            pagination: pageObj,
            pageLoader: false,
          });
        }
      } else {
        this.searchStudentInfo(pagination.current);
      }
    } catch (err) {
      console.log(err);
    }
  }

  searchBarUpdate(e) {
    this.setState({
      searchname: e.target.value,
    });
  }

  async searchStudentInfo(val) {
    try {
      let searchname = this.state.searchname;
      let finalSchool_id = JSON.parse(localStorage.getItem("finalSchool_id"));
      // let finalBoard_id = JSON.parse(localStorage.getItem('finalBoard_id'));
      let gradeName =
        localStorage.getItem("selectedGrade_Name") !== "undefined" &&
        localStorage.getItem("selectedGrade_Name")
          ? localStorage.getItem("selectedGrade_Name")
          : this.state.userData.grade_name;
      let selectedGrade_id_statisticApi = localStorage.getItem(
        "selectedGrade_id_statisticApi"
      );
      let result;
      this.setState({
        pageLoader: true,
      });
      if (selectedGrade_id_statisticApi === "") {
        result = await axios.post(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/searchuser-dev",
          {
            schoolId: this.props.schoolId,
            gradeId: this.state.gradeId,
            grade: gradeName,
            param: "all",
            page: val,
            search: searchname,
            subjectId: this.state.subjectId,
            chapterId: this.state.chapterId,
            topicId: this.state.topicId,
          }
        );
      } else {
        result = await axios.post(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/searchuser-dev",
          {
            schoolId: this.props.schoolId,
            gradeId: this.state.gradeId,
            grade: gradeName,
            page: val,
            search: searchname,
            subjectId: this.state.subjectId,
            chapterId: this.state.chapterId,
            topicId: this.state.topicId,
          }
        );
      }
      result = result.data;
      console.log(result);
      let searchStuData = result.search.user;
      console.log(searchStuData);
      if (searchStuData !== undefined) {
        for (let i = 0; i < searchStuData.length; i++) {
          searchStuData[i].key = i;
        }
        let pagiObj = {};
        pagiObj.total = result.search.totalCount;
        pagiObj.current = val;

        this.setState({
          studentTblData: searchStuData,
          pagination: pagiObj,
          searchFlag: true,
          pageLoader: false,
        });
      } else {
        this.setState({
          studentTblData: [],
          pagination: {},
          searchFlag: false,
          pageLoader: false,
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  resetStudentInfoTbl() {
    this.setState({
      pageLoader: true,
    });

    // let propdata = this.props.state;
    let propdata = {
      gradeId: this.prop,
    };
    let currentSelectedFlg = this.state.currentSelectedFlg;
    let chapterobj = {};
    chapterobj.chapter_id = this.state.chapterId;
    chapterobj.chapter_name = this.state.chapter_name;
    let topicobj = {};
    topicobj.topic_id = this.state.topicId;
    topicobj.topic_name = this.state.topic_name;
    if (currentSelectedFlg === "subject") {
      this.getData(propdata);
    } else if (currentSelectedFlg === "chapter") {
      this.getchapterDrillData(chapterobj);
    } else if (currentSelectedFlg === "topic") {
      this.getTopicDrillData(topicobj);
    }
    this.setState({
      searchname: "",
      searchFlag: false,
      pageLoader: false,
    });
  }

  async downloadCsv() {
    try {
      let gradeId = localStorage.getItem("selectedGrade_id");
      let finalSchool_id = localStorage.getItem("finalSchool_id");
      let gradeName =
        localStorage.getItem("selectedGrade_Name") !== "undefined" &&
        localStorage.getItem("selectedGrade_Name")
          ? localStorage.getItem("selectedGrade_Name")
          : this.state.userData.grade_name;
      let selectedGrade_id_statisticApi = localStorage.getItem(
        "selectedGrade_id_statisticApi"
      );
      let downloadCsvResult;
      if (
        selectedGrade_id_statisticApi === "" ||
        selectedGrade_id_statisticApi === null
      ) {
        downloadCsvResult = await axios.post(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/schoolreport/downloadgradecsv-dev",
          {
            schoolId: this.props.schoolId,
            gradeId: this.state.gradeId,
            subjectId: this.state.subjectId,
            chapterId: this.state.chapterId,
            topicId: this.state.topicId,
            grade: gradeName,
            param: "all",
          }
        );
      } else {
        downloadCsvResult = await axios.post(
          "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/schoolreport/downloadgradecsv-dev",
          {
            schoolId: this.props.schoolId,
            gradeId: this.state.gradeId,
            subjectId: this.state.subjectId,
            chapterId: this.state.chapterId,
            topicId: this.state.topicId,
            grade: gradeName,
          }
        );
      }
      downloadCsvResult = downloadCsvResult.data;
      window.open(downloadCsvResult.path, "_blank"); //to open new page
    } catch (err) {
      console.log(err);
    }
  }

  async downloadChapterwiseCsv(param) {
    try {
      let finalSchool_id = localStorage.getItem("finalSchool_id");
      let gradeName =
        localStorage.getItem("selectedGrade_Name") !== "undefined" &&
        localStorage.getItem("selectedGrade_Name")
          ? localStorage.getItem("selectedGrade_Name")
          : this.state.userData.grade_name;
      let downloadChapterwiseCsvResult = await axios.post(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/principal/schoolreport/chapterwisereport-dev",
        {
          schoolId: this.props.schoolId,
          gradeId: this.state.gradeId,
          grade: gradeName,
          subjectId: this.state.subjectId,
          chapterId: this.state.chapterId,
          action: param,
        }
      );
      downloadChapterwiseCsvResult = downloadChapterwiseCsvResult.data;
      window.open(downloadChapterwiseCsvResult.path, "_blank"); //to open new page
    } catch (err) {
      console.log(err);
    }
  }

  componentDidMount() {
    // let statisticsResult = JSON.parse(localStorage.getItem('indicator_gradewisedata'));
    // let schoolName = statisticsResult.school.school_name !== undefined ? statisticsResult.school.school_name : ''
    // this.props.login({ schoolName: schoolName })
    // let propdata = this.props.location.state
    const { user } = store.getState();
    this.setState({ userData: user });
    let propdata = {
      type: "Biology",
      schoolId: this.props.schoolId,
      gradeId: this.props.gradeId,
      subjectId: this.props.subjectId,
    };
    console.log(propdata);

    this.getData(propdata);
    this.setState({
      pageLoader: true,
    });
  }

  render() {
    let MainSubjectTitle = this.state.MainSubjectTitle;
    let tblTypeTitle = this.state.subjectTitle;
    // let ovsPercentage = this.state.ovsPercentage;
    // let ovStudentCount = this.state.ovStudentCount;
    let chapterDrillData = this.state.chapterDrillData;
    let topicDrillData = this.state.topicDrillData;
    let chapterSummaryArrData = this.state.chapterSummaryArrData;
    // let currentSelectedFlg = this.state.currentSelectedFlg
    let showCompletionSec = this.state.showCompletionSec;

    let finalRole = "";

    let studentTblcolumns = [
      // {
      //   title: 'User Id',
      //   dataIndex: 'user_id',
      //   key: 'user_id',
      // render: (selectedRowKeys, selectedRows) => (
      // <a href onClick={()=>this.getStudentDetail(selectedRowKeys, selectedRows)}>{selectedRowKeys}</a>
      // ),
      // },
      {
        title: "Full Name",
        dataIndex: "fullname",
        key: "fullname",
      },
      {
        // title: 'Knowledge Wealth',
        title: (
          <Tooltip>
            {" "}
            Score (%) &nbsp;&nbsp;&nbsp;{" "}
            <Tooltip title="It indicates the net learning outcomes calculated by adding learning efficiency and knowledge efficiency with a weightage of 20% & 80% respectively.">
              {" "}
              <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon>{" "}
            </Tooltip>
          </Tooltip>
        ),
        dataIndex: "knowledge_wealth",
        align:"right",
        key: "knowledge_wealth",
        render: (text) => (
          // <div className="gcoin_css gcoin_dmd">
          //     <img src={coin1} alt="dimond images" height={50} />
          //     <span className="coin_nums">{Math.round(text)}</span>
          //     <span className="coin_nums">{text}</span>
          // </div>
          <span className="">{text} %</span>
        ),
      },
      {
        // title: 'Knowledge Currency',
        title: (
          <Tooltip>
            {" "}
            Knowledge Efficiency (%)&nbsp;
            <Tooltip title="It measures the learning outcomes of the chapter-end quiz, where the student's conceptual clarity of all topics within that chapter is tested from the total score of 100.">
              {" "}
              <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon>{" "}
            </Tooltip>
          </Tooltip>
        ),
        dataIndex: "knowledge_currency",
        key: "knowledge_currency",
        align: "right",
        render: (text) => (
          // <div className="gcoin_css">
          //     <img src={coin2} alt="dimond images" height={50} />
          //     <span className="coin_nums">{Math.round(text)}</span>
          //     <span className="coin_nums">{text}</span>
          // </div>
          <span className="">{text} %</span>
        ),
      },
      {
        // title: 'Learning Currency',
        title: (
          <Tooltip>
            {" "}
            Learning Efficiency (%) &nbsp;
            <Tooltip title="It measures the learning outcomes achieved by a student in a topic. The speed, accuracy, and number of attempts are monitored and tested from the total score of 100.">
              {" "}
              <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon>{" "}
            </Tooltip>
          </Tooltip>
        ),
        dataIndex: "learning_currency",
        key: "learning_currency",
        align: "right",
        render: (text) => (
          // <div className="gcoin_css">
          //     <img src={coin3} alt="dimond images" height={50} />
          //     <span className="coin_nums">{Math.round(text)}</span>
          //     <span className="coin_nums">{text}</span>
          // </div>
          <span className="">{text} %</span>
        ),
      },
      // {
      //   title: 'Grade Rank',
      //   dataIndex: 'global_rank',
      //   key: 'global_rank',
      // },
      // {
      //   title: 'Time Alloted',
      //   dataIndex: 'time_alloted',
      //   key: 'time_alloted',
      // },
      {
        title: "Time Spent",
        dataIndex: "time_spend",
        key: "time_spend",
        render: (text) => (
          <span>{moment.utc(text * 1000).format("HH:mm:ss")}</span>
        ),
      },
      {
        // title: 'Last Played Chapter',
        title: (
          <Tooltip>
            Last Played Chapter&nbsp;{" "}
            <Tooltip title="It denotes the chapter last played by the student.">
              {" "}
              <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon>{" "}
            </Tooltip>
          </Tooltip>
        ),
        dataIndex: "chapter_name",
        key: "chapter_name",
      },
      {
        // title: 'Last Played Topic',
        title: (
          <Tooltip>
            Last Played Topic&nbsp;{" "}
            <Tooltip title="It denotes the topic last played by the student.">
              {" "}
              <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon>{" "}
            </Tooltip>
          </Tooltip>
        ),
        dataIndex: "topic_name",
        key: "topic_name",
      },
      {
        // title: 'Last Played Date',
        title: (
          <Tooltip>
            Last Played Date&nbsp;{" "}
            <Tooltip title="It denotes the date and time of the last played topic.">
              {" "}
              <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon>{" "}
            </Tooltip>
          </Tooltip>
        ),
        dataIndex: "playDate",
        key: "playDate",
      },
      {
        title: "",
        dataIndex: "",
        key: "x",
        align: "right",
        render: (selectedRowKeys, selectedRows) => (
          <Button
            className="btn btn-outline"
            type="primary"
            onClick={() => this.getStudentDetail(selectedRowKeys, selectedRows)}
          >
            View Details <icon className="icon-next"></icon>
          </Button>
        ),
      },
      {
        title: "",
        dataIndex: "",
        key: "x",
        render: (selectedRowKeys, selectedRows) =>
          finalRole == "qa" ? (
            <Button
            className="btn btn-outline"
              onClick={() => this.reIndexData(selectedRowKeys, selectedRows)}
            >
              Reindex
            </Button>
          ) : (
            ""
          ),
      },
    ];

    if (this.state.topicFlag === true) {
      studentTblcolumns = [
        {
          title: "Full Name",
          dataIndex: "fullname",
          key: "fullname",
        },
        {
          // title: 'Learning Currency',
          title: (
            <Tooltip>
              {" "}
              Learning Efficiency (%) &nbsp;
              <Tooltip title="It measures the learning outcomes achieved by a student in a topic. The speed, accuracy, and number of attempts are monitored and tested from the total score of 100.">
                {" "}
                <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon>{" "}
              </Tooltip>
            </Tooltip>
          ),
          dataIndex: "learning_currency",
          key: "learning_currency",
          align: "right",
          render: (text) => (
            // <div className="gcoin_css">
            //     <img src={coin3} alt="dimond images" height={50} />
            //     <span className="coin_nums">{Math.round(text)}</span>
            // </div>
            <span className="">{text}</span>
          ),
        },
        {
          title: "Time Spent",
          dataIndex: "time_spend",
          key: "time_spend",
          render: (text) => (
            <span>{moment.utc(text * 1000).format("HH:mm:ss")}</span>
          ),
        },
        {
          title: "Action",
          dataIndex: "",
          key: "x",
          align: "right",
          render: (selectedRowKeys, selectedRows) => (
            <Button
              className="btn btn-outline"
              onClick={() =>
                this.getStudentDetail(selectedRowKeys, selectedRows)
              }
            >
              View Details <icon className="icon-next"></icon>
            </Button>
          ),
        },
        {
          title: "",
          dataIndex: "",
          key: "x",
          render: (selectedRowKeys, selectedRows) =>
            finalRole !== "school" ? (
              <Button
                className="btn btn-outline"
                onClick={() => this.reIndexData(selectedRowKeys, selectedRows)}
              >
                Reindex Data
              </Button>
            ) : (
              ""
            ),
        },
      ];
    }

    let studentTblData = this.state.studentTblData; // Table Data

    return (
      <div id="CommonPageHolder">
        <div
          id="subject-cards"
          className={`container-fluid subject-${mcqSubjectNames(
            MainSubjectTitle.toLowerCase()
          )}`}
        >
          <BlockUi
            tag="div"
            className="container-fluid"
            blocking={this.state.pageLoader}
            keepInView
          >
            {/* <Row>
                     <Col md="2">
                        <button aria-pressed="true" className="btn-square btn btn-primary btn-block" onClick={this.btnBack.bind(this)}  >
                            <i className="fa fa-step-backward mt-8" style={{ fontSize: 15, paddingRight: 10 }}></i>
                            Back to Dashboard
                        </button>
                     </Col>
                     </Row> */}
            <div className="row no-gutters top-fixed-bar head-bread-crumb-dashboard">
              {/* <div className="back-nav"  aria-pressed="true" onClick={this.btnBack.bind(this)}>
                               <icon className="icon-back-arrow"></icon>
                              </div> */}
              <div className="col bread-crumb px-0 pl-2">
                <strong>
                  {" "}
                  <span className="subject-circle-icon-bg-small float-left ">
                    <icon className="icon-biology "></icon>
                  </span>
                  {MainSubjectTitle} Summary
                </strong>
              </div>
              <div className="back-nav-btn text-right"></div>
            </div>

            <div className="card">
              <div className="dash-card-header">
                {/* {MainSubjectTitle} */}
                <strong> Summary</strong>
              </div>
              <CardBody>
                <Row className="stu-sum-flex">
                  <div className="student-count-card card">
                    <div className="text-center card-bg">
                      <strong className="text-value">
                        {this.state.subjectAttempt}
                      </strong>{" "}
                      <br />
                      <small> Total Students Attempted Subject </small>
                      <span style={{ fontSize: "30px" }}>
                        <icon
                          className={` icon-${mcqSubjectNames(
                            MainSubjectTitle.toLowerCase()
                          )}`}
                        />
                      </span>
                      <div className="chart-wrapper">
                        {/* <Line data={makeSparkLineData(0, brandPrimary)} options={sparklineChartOpts} width={100} height={30} /> */}
                      </div>
                    </div>
                  </div>

                  <div className="student-count-card card">
                    <div className="text-center card-bg">
                      <strong className="text-value">
                        {this.state.chapterAttempt}
                      </strong>{" "}
                      <br />
                      <small> Students Attempted Chapter</small>
                      <span style={{ fontSize: "30px" }}></span>
                      <div className="chart-wrapper">
                        {/* <Line data={makeSparkLineData(1, brandDanger)} options={sparklineChartOpts} width={100} height={30} /> */}
                      </div>
                    </div>
                  </div>

                  <div className="student-count-card card ">
                    <div className="text-center card-bg">
                      <strong className="text-value">
                        {this.state.topicAttempt}
                      </strong>{" "}
                      <br />
                      <small> Students Attempted Topic</small>
                      <span style={{ fontSize: "30px" }}></span>
                      <div className="chart-wrapper">
                        {/* <Line data={makeSparkLineData(1, brandDanger)} options={sparklineChartOpts} width={100} height={30} /> */}
                      </div>
                    </div>
                  </div>
                </Row>

                <div className="row p-2">
                  <div className="col-md-12 mt-2 mb-4 text-bold"> Chapter Wise Progress</div>
                  <div className="col-md-12" id="subject-cards">
                    {chapterSummaryArrData.map((object, i) => {
                      return (
                        <Fragment>
                        <div className="text-left"> {object.chapter} - (Total Students -{" "}
                          {object.studentCount}) - {object.percentCount}%{" "}</div>
                        <Progress
                          value={object.percentCount}
                          className="mb-3   customProgressbar  "
                          barClassName="progress-bar-subject"
                          key={i}
                        >
                         
                        </Progress>
                        </Fragment>
                       
                      );
                    })}
                  </div>
                </div>

                {/* {chapterSummaryArrData.map((object, i) => {
                                  return (
                                <Progress value={object.percentCount} className="mb-3 customProgressbar" key={i}>{object.chapter} - (Total Students - {object.studentCount}) - {object.percentCount}%  </Progress>
                                  )
                                })} */}
              </CardBody>
            </div>

            <Card className="card-shadow">
              <CardHeader className="dash-card-header">
                {/* {MainSubjectTitle} */}Chapters-Topics
              </CardHeader>
              <CardBody className="pt-0 pb-2">
                <Row>
                  <div className="col-sm-12 m-2">
                    <strong className="h5">Chapters</strong>
                  </div>
                  <Col sm="12" className="mx-2">
                    {chapterDrillData.map((object, i) => {
                      return (
                        <Button
                          className={`btn btn-btn-outline  m-2 ${
                            object.chapter_name === this.state.chapter_name
                              ? "card-button-default "
                              : ""
                          }`}
                          key={i}
                          onClick={() => this.getchapterDrillData(object)}
                        >
                          {object.chapter_name}
                        </Button>
                      );
                    })}
                  </Col>
                </Row>

                <Row
                  className="mb-2"
                  style={{ display: topicDrillData.length === 0 ? "none" : "" }}
                >
                  <div className="col-md-12 mt-0 m-2">
                    <strong className="h5">Topics </strong>
                  </div>
                  <div className="col-md-12 mx-2">
                    {topicDrillData.map((object, i) => {
                      return (
                        <Button
                          className={`btn btn-outline   m-2 ${
                            object.topic_name === this.state.topic_name
                              ? "card-button-default "
                              : ""
                          }`}
                          danger
                          key={i}
                          onClick={() => this.getTopicDrillData(object)}
                        >
                          {object.topic_name}
                        </Button>
                      );
                    })}
                  </div>
                </Row>
              </CardBody>
            </Card>
            {/* ----------------------------------------------- */}
            <Card style={{ display: showCompletionSec !== true ? "none" : "" }}>
              <CardBody>
                <div className="d-f-c ">
                  <div className="dash-card-fail text-center">
                    Total Students Not Completed Chapter
                    <br />
                    <div className="d-f-c">
                      <button
                        className="btn btn-outline-none text-white text-center"
                        onClick={() =>
                          this.downloadChapterwiseCsv("chapterAttempt")
                        }
                      >
                        <div className="d-f-c">
                          <div className="detail-number">
                            {this.state.notCompletedchapter}
                          </div>
                          <div className="detail-value">
                            <icon className="icon-install" aria-hidden="true">
                              {" "}
                            </icon>
                          </div>
                          <div className="detail-value">CSV</div>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div className="dash-card-success text-center">
                    Total Students Completed Chapter
                    <br />
                    <div className="d-f-c">
                      <button
                        className="btn btn-outline-none text-white text-center"
                        onClick={() =>
                          this.downloadChapterwiseCsv("chapterComplete")
                        }
                      >
                        <div className="d-f-c">
                          <div className="detail-number">
                            {this.state.chapterCompletion}
                          </div>

                          <div className="detail-value">
                            <icon className="icon-install" aria-hidden="true">
                              {" "}
                            </icon>
                          </div>

                          <div className="detail-value">CSV</div>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div className="dash-card-success text-center">
                    Total Students Attempted Topic
                    <br />
                    <div className="d-f-c">
                      <button
                        className="btn btn-outline-none text-white text-center"
                        onClick={() =>
                          this.downloadChapterwiseCsv("topicAttempt")
                        }
                      >
                        <div className="d-f-c">
                          <div className="detail-number">
                            {this.state.onlyTopicAttempt}
                          </div>
                          <div className="detail-value">
                            <icon className="icon-install" aria-hidden="true">
                              {" "}
                            </icon>
                          </div>
                          <div className="detail-value">CSV</div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Card>
              <CardHeader className="dash-card-header">
                {tblTypeTitle} - Student List
              </CardHeader>
              <CardBody className="pt-0">
                <div className="row no-gutters mt-2 d-f-c width-100 ">
                  <div className="col-md-6 p-2 text-right">
                    {/* <Label htmlFor="text-input">Search :</Label> */}
                    <Input
                      type="text"
                      id="studentName"
                      name="studentName"
                      placeholder="Name"
                      value={this.state.searchname}
                      onChange={this.searchBarUpdate.bind(this)}
                    />
                  </div>
                  <div className="width-auto  searchbuttongrp text-right">
                    <Button
                      type="submit"
                      size="sm"
                      color="primary"
                      onClick={this.searchStudentInfo.bind(this, 1)}
                    >
                      <icon
                        className="icon-search-01"
                        aria-hidden="true"
                      ></icon>
                    </Button>
                    <Button
                      type="submit"
                      size="sm"
                      color="primary"
                      onClick={this.resetStudentInfoTbl.bind(this)}
                    >
                      <icon className="icon-refresh" aria-hidden="true"></icon>
                    </Button>
                    <Button
                      type="button"
                      size="sm"
                      color="primary"
                      onClick={this.downloadCsv}
                    >
                      <icon className="icon-install" aria-hidden="true"></icon>
                      <span> &nbsp;csv &nbsp;</span>
                    </Button>
                  </div>

                  <Col sm="12">
                    {/* <Col md="3" className="searchbuttongrp text-right">
                        <Button
                          type="submit"
                          size="sm"
                          color="primary"
                          onClick={this.searchStudentInfo.bind(this, 1)}
                        >
                          <i className="fa fa-search" aria-hidden="true"></i>
                        </Button>
                        <Button
                          type="submit"
                          size="sm"
                          color="primary"
                          onClick={this.resetStudentInfoTbl.bind(this)}
                        >
                          <i className="fa fa-refresh" aria-hidden="true"></i>
                        </Button>
                        <Button
                          type="button"
                          size="sm"
                          color="primary"
                          onClick={this.downloadCsv}
                        >
                          <i className="fa fa-download" aria-hidden="true"></i>
                          <span>csv</span>
                        </Button>
                      </Col> */}

                    <Table
                      pagination={this.state.pagination}
                      columns={studentTblcolumns}
                      dataSource={studentTblData}
                      onChange={this.handleTableChange}
                    />
                  </Col>
                </div>
              </CardBody>
            </Card>
            {/* <Card>
                    <CardBody className="pt-0">
                        <br />
                        <Row>
                            <Col sm="12">
                                <div className="callout callout-warning mt-0">
                                    <strong className="h5">{tblTypeTitle}  -  Overall Score</strong>
                                </div>
                                <BarChart labels={ovsPercentage} data={ovStudentCount} height={70} />
                            </Col>
                        </Row>
                    </CardBody>
                </Card> */}
          </BlockUi>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TeacherDashboard)
);
